module.exports = __webpack_public_path__ + "media/images/sprangrulla-b07a60106794d6078eee38b1d372db2d.jpg";